import { useEffect, useState } from 'react'
import { GenericHeaderBackButton } from 'src/consumer/components/ActivityPlansPage/MyPlanComponents'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithParams } from 'src/mentor/services'
import { AvailabilityPageContainer } from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import MentorHeader from '../MentorHeader'
import FeeModelsDisplay from './components/FeeModelsDisplay'

export default function EngagementModels() {
  //   const { associatedClinicBrands, associatedClinicsData, loadingAssociationsData } =
  //     useContext(MentorClinicsContext)

  const [loading, setLoading] = useState(false)
  const [entityFeeModels, setEntityFeeModels] = useState()
  const [inApplicableEntityFeeModels, setInApplicableEntityFeeModels] = useState()
  const [feeModels, setFeeModels] = useState()
  const [feeModelGroups, setFeeModelGroups] = useState()

  async function getFeeModels() {
    const resp = await getMPDataWithParams('/api/secure/teacher/entity-fee-model/list', {})
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setEntityFeeModels(data?.['entity-fee-model'])
        setInApplicableEntityFeeModels(data?.['inApplicable__entity-fee-model'])
        setFeeModels(data?.['fee-model'])
      }
    }
  }

  async function getFeeModelGroups() {
    const resp = await getMPDataWithParams('/api/secure/teacher/fee-model-group/list')
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setFeeModelGroups(data?.['fee-model-group'])
      }
    }
  }

  async function setup() {
    setLoading(true)
    await getFeeModels()
    await getFeeModelGroups()
    setLoading(false)
  }

  useEffect(() => {
    setup()
  }, [])

  //   useEffect(() => {
  //     if (associatedClinicBrands) {
  //       setSelectedClinicBrandId(associatedClinicBrands?.[0])
  //     }
  //   }, [associatedClinicBrands])

  console.log({ feeModels, entityFeeModels, inApplicableEntityFeeModels, feeModelGroups })

  return (
    <AvailabilityPageContainer>
      <MentorHeader showBackButton heading="Engagement Models" />
      <GenericHeaderBackButton
        clickfunction={() => window.history.back()}
        styles={{ margin: '20px' }}
      />
      <FeeModelsDisplay
        entityFeeModels={entityFeeModels}
        inApplicableEntityFeeModels={inApplicableEntityFeeModels}
        feeModels={feeModels}
        feeModelGroups={feeModelGroups}
        forMentor={true}
        loading={loading}
      />
    </AvailabilityPageContainer>
  )
}
